import { CleanContent } from './ui';
import { Link } from "react-router-dom";

export default function FooterNote() {
  return (
    <CleanContent> 
         <footer className="selectezi-footer p-3">
  <div className=" d-flex align-items-center justify-content-between flex-wrap gap-2">
    <span>
      &copy; 2025 SELECTEZI Inc. All rights reserved.
    </span>

    <div className="d-flex align-items-center gap-3">
      <Link to="/general-terms">General Terms</Link>
      <Link to="/privacy-policy">Privacy Policy</Link>
    </div>
  </div>
</footer></CleanContent>
  );
}
